// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rrUSu","field":"styles_field__3KtOg","fieldCol":"styles_fieldCol__2a6v0","diffCol":"styles_diffCol__3_amj","diff":"styles_diff__3YSWn"};